export default __webpack_public_path__ + "static/media/wave-home.c07a216f.gif";